import { MouseEventHandler } from 'react'
import { ReactSVG } from 'react-svg'

import { cn } from '@shared/lib/cn'
import Button, { type ButtonShapeVariant, type ButtonSizeVariant } from '@shared/ui/button'

import styles from './styles.module.scss'

interface DeleteProductProps {
  className?: string;
  onClick?: MouseEventHandler;
  size?: ButtonSizeVariant
  shape?: ButtonShapeVariant
}

export default function DeleteProduct (props: DeleteProductProps) {
  const { className, onClick, size, shape } = props

  return (
    <Button
      className={cn(styles.root, className)}
      theme="grey"
      size={size}
      shape={shape}
      onClick={onClick}
    >
      <ReactSVG src="/icons/trash.svg" wrapper="span" />
    </Button>
  )
}
